import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAuthInitialState } from "../types";
import Cookies from "js-cookie";

const initialState: IAuthInitialState = {
    token: "",
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload;

            Cookies.set("token", action.payload, {
                expires: 14,
                path: "/",
                secure: true,
                sameSite: "strict",
            });
        },
        clearToken: state => {
            state.token = "";
            Cookies.remove("token");
        },
    },
});

export const { setToken, clearToken } = authSlice.actions;
export default authSlice;
